<template>
<svg :class="svgClass" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
<path d="M137.8,943.6c0,25.6-20.8,46.4-46.4,46.4H56.4C30.8,990,10,969.3,10,943.6V695.5c0-25.6,20.8-46.4,46.4-46.4h35.1c25.6,0,46.4,20.8,46.4,46.4V943.6z
M350.9,943.6c0,25.6-20.8,46.4-46.4,46.4h-35.1c-25.6,0-46.4-20.8-46.4-46.4V610.3c0-25.6,20.8-46.4,46.4-46.4h35.1c25.6,0,46.4,20.8,46.4,46.4V943.6z
M563.9,943.6c0,25.6-20.8,46.4-46.4,46.4h-35.1c-25.6,0-46.4-20.8-46.4-46.4v-376c0-25.6,20.8-46.4,46.4-46.4h35.1c25.6,0,46.4,20.8,46.4,46.4V943.6z
M777,943.6c0,25.6-20.8,46.4-46.4,46.4h-35.1c-25.6,0-46.4-20.8-46.4-46.4V482.4c0-25.6,20.8-46.4,46.4-46.4h35.1c25.6,0,46.4,20.8,46.4,46.4V943.6z
M990,943.6c0,25.6-20.8,46.4-46.4,46.4h-35.1c-25.6,0-46.4-20.8-46.4-46.4V397.2c0-25.6,20.8-46.4,46.4-46.4h35.1c25.6,0,46.4,20.8,46.4,46.4V943.6z
M22.3,543.6L18.6,509c4-0.4,398.9-47,865.9-436.5l22.2,26.7C431,496,38.8,541.9,22.3,543.6z
M947.4,10v157.1L808.7,10H947.4z"/>
</svg>
</template>

<script>

export default {
    name: 'PredictionIcon',
    props: {
        svgClass: String
    }
}
</script>